import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import linkManageData from '../datas/link-manage'
export default {
  linkTrackOfAll (ctx, data) {
    return fetch.linkTrackOfAll(data).then(res => {
      let result = getTotalNumber(res)
      result.data = linkManageData.linkTrackOfAll(res.data)
      return result
    })
  },
  creatLink (ctx, data) {
    return fetch.creatLink(data).then(res => {
      return res.data
    })
  },
  deleteLink (ctx, id) {
    return fetch.deleteLink(id).then(res => {
      return res.data
    })
  }
}
